import { useMutation } from '@tanstack/react-query'

import { LearningItem } from '../../models/LearningItem'
import * as api from '../api'
import useInvalidate from '../useInvalidate'

export default function useFinishLearningItem() {
  const invalidate = useInvalidate()

  return useMutation({
    mutationFn: async ({
      courseUuid,
      learningItemKind,
      scheduledCourseEventUuid,
      userUuid,
    }: {
      courseUuid: string
      learningItemKind: LearningItem['kind']
      scheduledCourseEventUuid?: string
      userUuid: string
    }) => {
      if (learningItemKind === 'onDemandCourse') {
        await api.post(`on-demand-course/${courseUuid}/finish`, {
          user_uuid: userUuid,
        })
      } else if (learningItemKind === 'scheduledCourse') {
        await api.post(`scheduled-course/${courseUuid}/finish`, {
          user_uuid: userUuid,
          event_uuid: scheduledCourseEventUuid,
        })
      } else if (learningItemKind === 'learningPath') {
        await api.patch(`learning-path/${courseUuid}/finish`, {
          user_uuid: userUuid,
        })
      } else {
        throw new Error(`Can not finish learning item of this kind`)
      }

      await invalidate.userLearningAssignments()
    },
  })
}
